export default __webpack_public_path__ + "static/media/Group2131.e760f415.png";